module.exports = __webpack_public_path__ + "img/1281409408.94202d48.jpg";